import { useEffect } from "react";

const GoogleAdSense = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3736638010601568";
    document.body.appendChild(script);
  }, []);

  return null;
};

export default GoogleAdSense;
